import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useNavigate } from "react-router-dom";
import icons from "../../../resources/icons";
import * as navigationLinks from "../../../utils/links";
import EntityScoreButton from "../EntityScoreButton";
import classes from "./RecipesItem.module.css";

const RecipeItem = ({ data, style, isLoading = true }) => {
  const recipe = data;
  const navigate = useNavigate();

  const onRecipeClick = () => {
    navigate(navigationLinks.linkToRecipe(recipe.id, recipe.name));
  };

  return (
    <div className={`${style} ${classes.mainContainer} `} onClick={onRecipeClick}>
      <div className={classes.imageContainer}>
        {isLoading ? (
          <Skeleton
            height="100%"
            style={{
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
            }}
          />
        ) : (
          <img className={classes.image} src={recipe.logo} alt="recipe logo" />
        )}
      </div>
      <div className={classes.contentContainer}>
        <p className={classes.recipeTitle}>
          {isLoading ? <Skeleton borderRadius="20px" width="80%" /> : recipe.name}
        </p>
        <p className={classes.recipeDescription}>{recipe.about ? recipe.about.trim() : ""}</p>
        {recipe.recipe_categories && (
          <div className={classes.tagContainer}>
            <img className={classes.tagIcon} src={icons.greyTag} alt="tag icon" />
            {recipe.recipe_categories.map((category, index, row) => (
              <p className={classes.tag} key={category.category_name}>
                {category.category_name}
                {index !== row.length - 1 ? ", " : ""}
              </p>
            ))}
          </div>
        )}
        <EntityScoreButton entity={recipe} isLoading={isLoading} />
      </div>
    </div>
  );
};

export default RecipeItem;
